module.exports = __webpack_public_path__ + "img/accessory_pants_03.f48bb0e7.svg";